import { gql } from '@apollo/client'

export const TRIGGER_PAYOUT_MUTATION = gql`
  mutation triggerPayout($payoutId: ID!) {
    triggerPayout(payoutId: $payoutId) {
      id
    }
  }
`
